import React from 'react';
export const PermissionsContext = React.createContext(null);
//# sourceMappingURL=permissions-context.js.map